import { connect } from 'react-redux';
import { getSettings, getBrowserCapabilities } from '../../selectors/settings';
import {
    getConvo,
    getMessages,
    getNumUnreadMessages,
    hasRecentVideoRequest,
} from '../../selectors/conversation';
import { requestMarkRead, acceptVideoRequest } from '../../actions';
import { RootState } from '../../typedefs/store';
import MessageList from './MessageList';

const mapStateToProps = (state: RootState, ownProps: any) => {
    const convo = getConvo(state);
    const settings = getSettings(state);
    const browserCapabilities = getBrowserCapabilities(state);
    return {
        messages: getMessages(state),
        typingStatus: convo.typingStatus,
        convoAvatar: convo.avatar,
        ended: convo.ended,
        numUnread: getNumUnreadMessages(state),
        webRtcSupported: browserCapabilities.webRtc,
        showVideoRequest: hasRecentVideoRequest(state),
        agent: convo.users.length > 0 && convo.users[0],
        openLinksExternally: settings.openLinksExternally,
    };
};

const mapDispatchToProps = { requestMarkRead, acceptVideoRequest };

export default connect(mapStateToProps, mapDispatchToProps)(MessageList);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/MessageListContainer.tsx